import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "../root/config.store";
import {
  ImageDetails,
  ImagesPayload,
  initialState,
} from "../../types/orderhistoryimage";

// slice
export const imageDetailsSlice = createSlice({
  name: "imageDetails",
  initialState,
  reducers: {
    fetchImageisLoading(state, action: PayloadAction<ImagesPayload>) {
      state.loading = true;
    },
    fetchImageSucceeded(state, action: PayloadAction<ImageDetails>) {
      state.data = action.payload;
      state.loading = false;
    },
    fetchImageFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetImageDetails(state) {
      return initialState; // Resets to initial state
    },
  },
});

// Actions
export const orderHistoryImageActions = {
  fetchImageisLoading: imageDetailsSlice.actions.fetchImageisLoading,
  fetchImageSucceeded: imageDetailsSlice.actions.fetchImageSucceeded,
  fetchImageFailure: imageDetailsSlice.actions.fetchImageFailure,
  resetImageDetails : imageDetailsSlice.actions.resetImageDetails
};

// Selectors
export const imageDetails = (state: RootState): ImageDetails =>
  state.imageDetails?.data ?? null;

// Reducer
export default imageDetailsSlice.reducer;
